module.exports = __webpack_public_path__ + "media/images/reseller--e908ddbf1bb2231c826f5694d460a652.jpg";